import React from "react";
import ReactDOM from "react-dom/client";
import { OnePager } from "./OnePager";
import { Website } from "./Website";
import "./style.css";

function App() {
	const path = window.location.pathname;

	if (path === "/one-pager") {
		return <OnePager />;
	}

	return <Website />;
}

function run() {
	const container = document.createElement("main");
	document.body.appendChild(container);
	ReactDOM.createRoot(container).render(<App />);
}

run();
